import App from './App.vue'
import { Vue, i18n, router, store } from './main-common'
import { openInit } from './init'
import currency from '@/utils/currency'
import { omega } from '@/lib/omega'
import '@/assets/scss/font.scss'
import SodaMasMonitor from '@didi/soda-mas-monitor'

initialize([
  currency.init(), // 50ms 延时
]).then(() => {
  init()
})

function init() {
  openInit().then(() => {
    // eslint-disable-next-line no-new
    new SodaMasMonitor({
      env: process.env.NODE_ENV,
      Omega: omega,
      openTestTrack: true,
    })
    new Vue({
      i18n,
      router,
      store,
      render: h => h(App),
    }).$mount('#app')

    // 在 $mount 之后动态加载登录脚本
    const loginScript = document.createElement('script')
    loginScript.src = '//static.didiglobal.com/common-biz/global-login/2.4.5/login.global.min.js'
    loginScript.defer = true
    loginScript.async = true
    loginScript.onload = () => {
      console.log('login.global.min.js loaded')
    }
    loginScript.onerror = () => {
      console.error('login.global.min.js load failed')
    }
    document.head.appendChild(loginScript)

    // 优化：等待 Vue 应用完全渲染后再隐藏 loading
    // 使用多层保障确保内容已渲染
    const hideLoading = () => {
      const loadingEl = document.getElementById('app-loading')
      if (!loadingEl || loadingEl.classList.contains('hidden')) return

      // 检查 #app 中是否有实际内容渲染
      const appEl = document.getElementById('app')
      if (appEl && appEl.children.length > 0) {
        loadingEl.classList.add('hidden')
        loadingEl.parentNode.removeChild(loadingEl)
      }
    }

    hideLoading()
  })
}

function initialize(promiseArr) {
  return Promise.all(promiseArr)
}
